import React, { useState, useEffect } from "react";
import ScrollMenu from "react-horizontal-scrolling-menu";
import content_copy from "@safecv/assets/Images/content_copy.svg";
import close from "@safecv/assets/Images/close.svg";
import { connect } from "react-redux";
import toast from "@safecv/shared/toast";
import MESSAGE from "@safecv/shared/message";
import EsInfo from "../../../assets/Images/enhancedsearchinfo.svg";

const CommentsRepository = (props) => {
  const {
    setCommentRepo,
    allComments,
    topComments,
    myComments,
    showMoreMyComments,
    showMoreComments,
    activeDiscipline,
    setActiveDiscipline,
    showMoreAllComments,
    setSearchText,
  } = props;
  //props received from parent component can be used
  const [selectedMenu, setSelectedmenu] = useState(null);
  const [currentSearchText, setcurrentSearchText] = useState("");

  useEffect(() => {
    setSelectedmenu(props.activeDiscipline);
    setcurrentSearchText("");
  }, [props.activeDiscipline]);

  const list =
    props.disciplines &&
    props.disciplines.map((item) => {
      return { name: item.name, id: item.id };
    });

  // One item component
  // selected prop will be passed
  const MenuItem = ({ text, selected, id }) => {
    return (
      <div id={id} className={`menu-item ${selected ? "active" : ""}`}>
        {text}
      </div>
    );
  };

  // All items component
  // Important! add unique key

  const Menu = (list, selected) =>
    list &&
    list.map((el) => {
      const name = el.name;
      const id = el.id;
      return <MenuItem id={id} text={name} key={id} selected={selected} />;
    });

  const Arrow = ({ text, className }) => {
    if (text) return <div className={className}> </div>;
  };

  const ArrowLeft = Arrow({ text: "<", className: "arrow-prev" });
  const ArrowRight = Arrow({ text: ">", className: "arrow-next" });

  const menuItems = Menu(list, selectedMenu);

  const onSelect = (id) => {
    setSelectedmenu(id);
    setActiveDiscipline(id);
    setSearchText("");
  };

  const copyToClipboard = (textToCopy) => {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(textToCopy);
    } else {
      let textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise((res, rej) => {
        document.execCommand("copy") ? res() : rej();
        textArea.remove();
      });
    }
  };

  const handleCopy = (e, section, index) => {
    let copiedText =
      section === "topComments"
        ? topComments[index].comment
        : section === "myComments"
        ? myComments[index].comment
        : allComments[index].comment;
    copyToClipboard(copiedText)
      .then(() => toast.success(MESSAGE.COPY_SUCCESS))
      .catch(() => toast.error(MESSAGE.COPY_FAILURE));
  };

  const handleAllCopy = async () => {
    let copiedText =
      topComments &&
      topComments.length > 0 &&
      topComments.map((item) => {
        return item.comment + "\n";
      });
    copyToClipboard(copiedText.join(" "))
      .then(() => toast.success(MESSAGE.COPY_SUCCESS))
      .catch(() => toast.error(MESSAGE.COPY_FAILURE));
  };

  const handleMyCopy = async () => {
    let copiedText =
      myComments?.length > 0 &&
      myComments.map((item) => {
        return item.comment + "\n";
      });
    copyToClipboard(copiedText.join(" "))
      .then(() => toast.success(MESSAGE.COPY_SUCCESS))
      .catch(() => toast.error(MESSAGE.COPY_FAILURE));
  };

  const closeCommentRepo = () => {
    setCommentRepo(false);
  };

  const ShowCommentsMore = (
    commentsSize,
    disciplineId,
    lastListId,
    section
  ) => {
    showMoreComments(commentsSize, disciplineId, lastListId, section);
  };

  const searchCommentRepo = (e) => {
    let searchVal = e.target.value;
    let searchtext = searchVal.replace(/[&\/\\_#@+=~'":*<>{}!|\[\]\-]/g, " ");
    var regex = /^[^a-zA-Z0-9]+$/;
    var onlySplChar = regex.test(searchVal);
    onlySplChar
      ? toast.error(MESSAGE.INVALID_SEARCH)
      : setSearchText(searchtext);
    setcurrentSearchText(e.target.value);
  };

  const topCommentsList =
    topComments &&
    topComments.length > 0 &&
    topComments.map((item, index) => {
      return (
        <li id={item.id}>
          {item.comment}
          <span onClick={(e) => handleCopy(e, "topComments", index)}>
            <img alt="" class="copy_image" src={content_copy} />
          </span>
        </li>
      );
    });

  const myCommentsList =
    myComments &&
    myComments.length > 0 &&
    myComments.map((item, index) => {
      return (
        <li id={item.id}>
          {item.comment}
          <span onClick={(e) => handleCopy(e, "myComments", index)}>
            <img alt="" class="copy_image" src={content_copy} />
          </span>
        </li>
      );
    });

  const allCommentsList =
    allComments &&
    allComments.length > 0 &&
    allComments.map((item, index) => {
      return (
        <li id={item.id}>
          {item.comment}
          <span onClick={(e) => handleCopy(e, "allComments", index)}>
            <img alt="" class="copy_image" src={content_copy} />
          </span>
        </li>
      );
    });

  const lastActiveId =
    myComments?.length > 0 && myComments[myComments.length - 1].id;

  const lastAllActiveId =
    allComments?.length > 0 && allComments[allComments.length - 1].id;

  // It renders Comments Repository.
  return (
    <div className="comment-repo-container">
      <div className="comment-repo-heading">
        <h3>Comments</h3>
        <img alt="" src={close} onClick={closeCommentRepo} />
      </div>
      <ScrollMenu
        hideArrows={true}
        hideSingleArrow={true}
        data={menuItems}
        alignCenter={false}
        alignLeft={true}
        arrowLeft={ArrowLeft}
        arrowRight={ArrowRight}
        selected={selectedMenu}
        onSelect={onSelect}
      />
      <br />
      <div className="searchBoxContainer">
        <input
          class="searchbox"
          id="comment-repo-search"
          type="text"
          placeholder="Search"
          value={currentSearchText}
          onChange={searchCommentRepo}
        ></input>
      </div>
      <div className="commentsContainer">
        {topComments?.length > 0 && (
          <div className="topCommentsContainer">
            <div className="topCommentsheading">
              <h3 style={{ marginBottom: "0px" }}>
                Top Comments{" "}
                <img
                  alt=""
                  src={EsInfo}
                  title="Comments prioritized and frequently used by reviewer's for each discipline during plan review"
                />
              </h3>
              <span onClick={() => handleAllCopy()}>Copy All Top Comments</span>
            </div>
            <ul id="alltopCommentsList">{topCommentsList}</ul>
          </div>
        )}
        {myComments?.length > 0 && (
          <div className="myCommentsContainer">
            <div className="myCommentsheading">
              <h3>
                My Comments{" "}
                <img
                  alt=""
                  src={EsInfo}
                  title="List of all comments from my comment repository"
                />
              </h3>
              {activeDiscipline == 0 && (
                <span onClick={() => handleMyCopy()}>Copy All Comments</span>
              )}
            </div>
            <ul>{myCommentsList}</ul>
            {showMoreMyComments && (
              <span
                id="showmore"
                onClick={() =>
                  ShowCommentsMore(
                    50,
                    activeDiscipline,
                    lastActiveId,
                    "mycomments"
                  )
                }
              >
                Show More Comments
              </span>
            )}
          </div>
        )}

        {allComments?.length > 0 && (
          <div className="allCommentContainer">
            <div className="allCommentheading">
              <h3>
                Other Comments{" "}
                <img
                  alt=""
                  src={EsInfo}
                  title="Compilation of comments used by all reviewer's during plan review"
                />
              </h3>
            </div>
            <ul>{allCommentsList}</ul>
            {showMoreAllComments && (
              <span
                id="showmore"
                onClick={() =>
                  ShowCommentsMore(
                    50,
                    activeDiscipline,
                    lastAllActiveId,
                    "allcomments"
                  )
                }
              >
                Show More Comments
              </span>
            )}
          </div>
        )}

        {(topComments?.length === 0 || topComments === null) &&
          (myComments?.length === 0 || myComments === null) &&
          (allComments?.length === 0 || allComments === null) && (
            <div className="noComments">There are no records to display</div>
          )}
      </div>
    </div>
  );
};

const mapStatetoProps = (state) => ({
  allComments: state.verification.allComments,
  myComments: state.verification.myComments,
  topComments: state.verification.topComments,
  showMoreAllComments: state.verification.showMoreAllComments,
  showMoreMyComments: state.verification.showMoreMyComments,
});

export default connect(mapStatetoProps, null)(CommentsRepository);
